// 引入外部工具函数
import * as Util from 'js/util/util'
import Cookie from 'js/lib/cookie'

/**
 * 重新装饰新的data
 */
function decorateData(res) {
  // 外层权限
  res.access_mode = Util.resolveFileAction(res.access_mode)
  res.content.forEach((content, index) => {
    // content.isfolder 解决与客户端判定文件夹的变量名不统一问题
    if (!content.is_dir && content.mime_type.indexOf('image') > -1) {
      content.preview_url = getPicRouter(content)
    }
    content.isfolder = content.isDir = content.is_dir
    // 先设置为false
    content.checked = false
    content.islocked = !!content.lock_uid
    content.accessMode = content.access_mode
    content.access_mode = Util.resolveFileAction(content.access_mode)
    content.canPreivew = Util.suppportPreview(content)
    // content.unlockAdmin = (content.lock_uid == Util.getUserID()) || Util.isAdmin();
    content.data = [{
      type: 'file',
      showRename: false,
      get value() {
        return content.filename ? content.filename : content.path.split('/').pop()
      },
      fileMore: [],
      class: 'filelist-icon',
      others: '',
      showIconGroup: 'show',
      // operate: null,
      // custom: { // 自定义
      //     icon: 'icon-msg-forewarning'
      // },
    }, {
      get value() {
        // 默认列表模式
        let isListMode = true
        if (localStorage.getItem('Mode') != '' && localStorage.getItem('Mode') != undefined) {
          isListMode = localStorage.getItem('Mode') === 'list'
        }
        const applyName = sessionStorage.getItem('rootName')
        if (isListMode) {
          return `${Util.formatDate(content.modified, 'yyyy-MM-dd hh:mm')} | ${applyName}`
        }
        return Util.formatDate(content.modified, 'yyyy-MM-dd hh:mm') + window.i18n.t(' 由<span title="{n}" class="update-creator">{n}</span>创建', { n: applyName })
      },
      class: 'update-date-updator',
    }, {
      get value() {
        return content.is_dir ? '-' : Util.formatBytes(content.bytes)
      },
      class: 'update-size',
    }]
  })
  return res
}

// 拼接图片预览地址
function getPicRouter(data) {
  const baseUrl = '/v2/preview_router?type=pic&root=databox'
  let query = ''
  const {
    neid,
    nsid,
    rev,
    hash,
    path,
    from,
    path_type: pathType,
  } = data
  const param = {
    width: 300,
    height: 150,
    path: encodeURIComponent(path),
    neid,
    nsid,
    rev,
    from,
    preview_agent: 'thumb',
    hash,
    pathType,
    S: Cookie.get('S'),
  }
  Object.keys(param).forEach((key) => {
    query += `&${key}=${param[key]}`
  })
  return `${baseUrl + query}`
}

/**
 * huangshuo
 * 获取完整的文件列表展示信息
 * @param linkData   //外联信息
 * @param callback  //回调函数
 * @returns {*}
 */
export function getFileList(linkData, callback) {
  // 装饰list
  const fileList = decorateData(linkData)
  // 吊用回调函数
  callback && callback(fileList)
}
